export default "__VITE_ASSET__BcsUwJtN__"